/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable security/detect-object-injection */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/no-unused-prop-types */
import { Dispatch, SetStateAction, memo, useEffect, useState } from "react";
import CustomBoxModal from "src/shared/CustomModalBox";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import CustomAutocomplete from "src/shared/CustomAutocomplete";
import { useFormik } from "formik";
import { caseReassignInitialValue, caseReassignValidationSchema } from "src/helpers/Dashboard";
import { Button } from "@mui/material";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { caseReassign, getUserList } from "src/services/Dashboard";
import CustomBackDrop from "src/shared/CustomBackDrop";
import { find } from "lodash";
import store from "src/redux/store";
import { SET_TOAST_ERROR } from "src/redux/Actions/common";

interface Props {
  onClose: Dispatch<SetStateAction<boolean>> | any;
  leadId: string;
  currIRM: Record<string, any>;
}
function CaseReassignModal({ onClose, leadId, currIRM }: Props) {
  const leadsData = useAppSelector((state) => state.dashboard?.data?.data)[leadId];
  const [userData, setUserData] = useState<string[]>([]);
  const queryClient = useQueryClient();
  const { data: irmData, isFetching: isGetUserListFetching } = useQuery(
    ["getUserList"],
    () =>
      getUserList({
        supervisorCode: leadsData?.QuoteIrmMapping?.level1SupervisorCode,
        supervisorLevel: leadsData?.QuoteIrmMapping?.level1SupervisorLevel,
        lgCode: leadsData?.employeeCode || leadsData?.QuoteIrmMapping?.irmCode
      }),
    {
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
      onSuccess: (response) => {
        document.body.style.overflow = "hidden";
        setUserData(response?.data?.map((option: any) => `${option.name} (${option.code})`));
      },
      onError: () => {
        store.dispatch(
          SET_TOAST_ERROR({
            error: true,
            duration: 3000,
            message: "Cannot Fetch Users List"
          })
        );
      }
    }
  );
  const { mutate: mutateCaseReassign, isLoading: isCaseReassignLoading } = useMutation(
    caseReassign,
    {
      retry: false,
      onSuccess: async () => {
        store.dispatch(
          SET_TOAST_ERROR({
            error: true,
            type: "success",
            duration: 2000,
            message: "Successfully Updated"
          })
        );
        onClose();
        await queryClient.invalidateQueries({ queryKey: ["dashboard"] });
      }
    }
  );
  const { errors, setFieldTouched, touched, values, setFieldValue, handleSubmit } = useFormik({
    enableReinitialize: true,
    validateOnMount: true,
    validateOnChange: true,
    validateOnBlur: true,
    initialValues: caseReassignInitialValue,
    validationSchema: caseReassignValidationSchema(),
    onSubmit: (fieldValues) => {
      const selectedUser = find(irmData?.data, [
        "code",
        fieldValues.supervisor
          ?.split("(")[1]
          ?.substring(0, fieldValues.supervisor?.split("(")[1].length - 1)
      ]);
      mutateCaseReassign({
        leadId,
        irmCode: selectedUser?.code,
        irmName: selectedUser?.name,
        irmLevel: selectedUser?.level,
        irmEmail: selectedUser?.email
      });
    }
  });
  useEffect(() => {
    setFieldValue("supervisor", `${currIRM?.irmName} (${currIRM?.irmCode})`);
  }, []);
  return (
    <>
      <CustomBackDrop open={isGetUserListFetching || isCaseReassignLoading} />
      {!isGetUserListFetching && (
        <CustomBoxModal onClose={onClose}>
          <div className="bg-white !rounded-lg px-10 py-8 max-w-92.5 h-full shadow-xl !text-sm space-y-5">
            <h1 className="font-bold text-base">Application No. {leadsData.applicationNo}</h1>
            <section className="space-y-2">
              <CustomAutocomplete
                onChange={async (inputValue) => {
                  await setFieldValue("supervisor", inputValue);
                }}
                setFieldTouched={setFieldTouched}
                label="Search"
                name="supervisor"
                value={values.supervisor}
                setFieldValue={setFieldValue}
                error={errors.supervisor}
                touched={touched.supervisor}
                options={userData}
              />
              <div className="text-center">
                <Button
                  disabled={
                    !values.supervisor ||
                    values.supervisor
                      ?.split("(")[1]
                      ?.substring(0, values.supervisor?.split("(")[1].length - 1) ===
                      leadsData?.QuoteIrmMapping?.irmCode
                  }
                  onClick={() => handleSubmit()}
                  variant="contained"
                  classes={{
                    contained:
                      "!rounded-lg !text-xs !leading-3.75 !-tracking-0.01 !font-montserrat !h-10 !uppercase"
                  }}
                  className=" !text-center"
                >
                  Re-assign
                </Button>
              </div>
            </section>
          </div>
        </CustomBoxModal>
      )}
    </>
  );
}

export default memo(CaseReassignModal);
